import { Pipe, PipeTransform } from '@angular/core';

import { TextAttributes } from '@shared/enums/customisation.enum';
import { CustomisationService } from '@shared/services/customisation/customisation.service';

@Pipe({
  name: 'customText'
})
export class CustomTextPipe implements PipeTransform {
  constructor(private customisationService: CustomisationService) {}

  transform(attribute: TextAttributes): string {
    return this.customisationService.getText(attribute);
  }
}
